import { Component, Input } from '@angular/core';
/**
 * This component exports the collection of items to a file of type XML, XLS, JSON or CSV
 *
 * This class should not be modified.
 *
 */
@Component({
  selector: 'app-export-data',
  templateUrl: './export-data.component.html'
})
export class ExportDataComponent {
  /**
   * The options like fileType, all or current fields
   */
  dataToExportOptions: any[];
  /**
   * The keys of the columns to export
   */
  keysOptions: any[];
  /**
   * The keys option to export, by default all keys
   */
  keys = 'All';
  /**
   * The data to export, by default the selected rows
   */
  dataToExport = 'Selected';
  /**
   * The supported files
   */
  availableFormats: string[] = ['XML2', 'Excel', 'CSV', 'Json'];

  @Input() context: any;

  @Input() label: string;

  @Input() icon: string;

  constructor () {
    this.dataToExportOptions = [
      { label: 'All', value: 'All' },
      { label: 'Selected', value: 'Selected' }
    ];
    this.keysOptions = [
      { label: 'All', value: 'All' },
      { label: 'Current', value: 'Current' }
    ];
  }
  /**
   * Exports the collection of items
   * @param format
   */
  exportData(format) {
    this.context.doExport(this.keys, this.dataToExport, format);
  }
  /**
   * Gets the format
   * @param event
   * @param overlaypanel
   */
  retrieveFormats(event, overlaypanel) {
    overlaypanel.show(event);
  }
}
